import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function CardsPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="cards" />

      {/* ===== PAGE HERO ===== */}
      <PageHero className="pageHero">
        <div className="container flexSpaceCenter">
          <HeroText className="hero-in">
            <PageTag className="pinkBg whiteColor radius6">המוצר שלנו</PageTag>
            <h1 className="font60 extraBold darkColor heroTitle" style={{ marginTop: "15px", lineHeight: "1.1" }}>
              קלפי נפש 🃏
            </h1>
            <p className="font18 darkColor" style={{ marginTop: "20px", lineHeight: "1.7", maxWidth: "500px" }}>
              הקלפים שלך הם השפה של הלב שלך.
              כלים ויזואליים שנוצרים בידיים שלך, בשפה שלך.
            </p>
          </HeroText>
          <HeroImageBox>
            {/* IMAGE PLACEHOLDER — swap for a hero photo of the cards */}
            <HeroImgPlaceholder className="radius8">
              <span>📸 תמונת גיבור: קלפים</span>
            </HeroImgPlaceholder>
          </HeroImageBox>
        </div>
      </PageHero>

      {/* ===== WHAT ARE CARDS ===== */}
      <Section className="lightBg">
        <div className="container">
          <TwoCol>
            <TextCol className="slide-right">
              <SectionLabel className="purpleColor font15 semiBold">הכרות</SectionLabel>
              <h2 className="font40 extraBold darkColor" style={{ margin: "10px 0 20px" }}>
                אז מהם הקלפים?
              </h2>
              <BodyText className="font15">
                קלפים הם כלים ויזואליים הכוללים דימוי, מילה או משפט.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                קלפים הם לא רק משחק, הם כלי אישי שיכול לשמש אותנו במגוון דרכים מרגשות ועוצמתיות.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                קלפים יכולים לעורר מחשבה, להניע תהליך רגשי או לעזור בהתבוננות פנימית.
              </BodyText>
            </TextCol>
            <ImageCol className="slide-left">
              {/* IMAGE PLACEHOLDER — swap for a photo of cards spread out */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--grad-blush)", height: "360px" }}>
                <span>📸 תמונת קלפים פרוסים</span>
              </ImgPlaceholder>
            </ImageCol>
          </TwoCol>
        </div>
      </Section>

      {/* ===== WHY MAKE YOUR OWN ===== */}
      <Section>
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">🌟 למה כדאי לך להכין קלפים משלך?</h2>
          </SectionHeader>

          {/* Reason 1 */}
          <ReasonRow>
            <ReasonImageBox>
              {/* IMAGE PLACEHOLDER — swap for a creative/personal photo */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "260px" }}>
                <span>📸 תמונה: קלפים אישיים</span>
              </ImgPlaceholder>
            </ReasonImageBox>
            <ReasonText>
              <ReasonIcon>🎨</ReasonIcon>
              <h3 className="font25 extraBold darkColor">כי הקלפים שלך מדברים בקול שלך</h3>
              <BodyText className="font15" style={{ marginTop: "15px" }}>
                כשאת יוצרת קלפים בעצמך, את בוחרת את המילים, הצבעים, הדימויים והכוונות.
                הם לא "עוד קלפים מהמדף", הם שלך. מותאמים בדיוק למה שאת צריכה, מרגישה, שואלת.
                הם בדיוק בשפה שלך. הם מבטאים את הקול הפנימי שלך.
              </BodyText>
            </ReasonText>
          </ReasonRow>

          {/* Reason 2 */}
          <ReasonRow reverse>
            <ReasonText>
              <ReasonIcon>💬</ReasonIcon>
              <h3 className="font25 extraBold darkColor">כי הם עוזרים לך להקשיב פנימה</h3>
              <BodyText className="font15" style={{ marginTop: "15px" }}>
                קלפים אישיים הם מראה עדינה. כל קלף שתצרי הוא פיסת אמת שלך.
                הם עוזרים לעקוף את הראש ה"רציונלי" ולגשת לעולמות פנימיים.
                ברגעים של חיפוש או קושי, הם יעזרו לך לשאול, להרגיש, להבין.
              </BodyText>
            </ReasonText>
            <ReasonImageBox>
              {/* IMAGE PLACEHOLDER — swap for a reflective/listening photo */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "260px" }}>
                <span>📸 תמונה: הקשבה פנימית</span>
              </ImgPlaceholder>
            </ReasonImageBox>
          </ReasonRow>

          {/* Reason 3 */}
          <ReasonRow>
            <ReasonImageBox>
              {/* IMAGE PLACEHOLDER */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "260px" }}>
                <span>📸 תמונה: נגישות</span>
              </ImgPlaceholder>
            </ReasonImageBox>
            <ReasonText>
              <ReasonIcon>✨</ReasonIcon>
              <h3 className="font25 extraBold darkColor">כי הם הופכים את העבודה הפנימית לנגישה</h3>
              <BodyText className="font15" style={{ marginTop: "15px" }}>
                תהליך אישי, מדיטציה, חיבור לרגש, לפעמים מרגיש "גדול" או מאיים.
                קלפים הם דרך פשוטה ויצירתית לעשות את זה בעצמך. בבית. בזמן שלך.
              </BodyText>
            </ReasonText>
          </ReasonRow>

          {/* Reason 4 */}
          <ReasonRow reverse>
            <ReasonText>
              <ReasonIcon>📚</ReasonIcon>
              <h3 className="font25 extraBold darkColor">כי הם כלי אמיתי לתרגול יומי</h3>
              <BodyText className="font15" style={{ marginTop: "15px" }}>
                השתמשי בהם כשאת מתלבטת, כועסת, חסרת אנרגיה או מלאת השראה.
                את יכולה להשתמש בהם גם כשאת מלאת הודיה...
                השתמשי בקלפים כדי לפתוח את הלב... בשיחות עם הילדים, בזוגיות, עם חברות.
              </BodyText>
            </ReasonText>
            <ReasonImageBox>
              {/* IMAGE PLACEHOLDER */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "260px" }}>
                <span>📸 תמונה: שימוש יומי</span>
              </ImgPlaceholder>
            </ReasonImageBox>
          </ReasonRow>

          {/* Reason 5 */}
          <ReasonRow>
            <ReasonImageBox>
              {/* IMAGE PLACEHOLDER */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "260px" }}>
                <span>📸 תמונה: למידה דרך יצירה</span>
              </ImgPlaceholder>
            </ReasonImageBox>
            <ReasonText>
              <ReasonIcon>🧠</ReasonIcon>
              <h3 className="font25 extraBold darkColor">כי את לומדת על עצמך דרך היצירה</h3>
              <BodyText className="font15" style={{ marginTop: "15px" }}>
                תהליך היצירה של הקלפים הוא לא רק "להכין משהו יפה".
                הוא מרפא. מחזק. מעורר שאלות. מאפשר.
              </BodyText>
            </ReasonText>
          </ReasonRow>
        </div>
      </Section>

      {/* ===== GALLERY ===== */}
      <GallerySection className="coralBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font30 extraBold darkColor">גלריית השראה 🎨</h2>
            <p className="font14 darkColor">כמה דוגמאות לקלפים שנוצרו בסדנאות שלנו</p>
          </SectionHeader>
          <GalleryGrid className="stagger-reveal">
            {[1,2,3,4,5,6].map((i) => (
              <GalleryItem key={i}>
                {/* IMAGE PLACEHOLDER — swap each for a real cards photo */}
                <GalleryImg className="radius8" style={{ background: i % 2 === 0 ? "var(--tint-butter)" : "var(--tint-paper)" }}>
                  <span>📸 קלף {i}</span>
                </GalleryImg>
              </GalleryItem>
            ))}
          </GalleryGrid>
        </div>
      </GallerySection>

      {/* ===== SUMMARY ===== */}
      <SummarySection className="pinkBg">
        <div className="container textCenter">
          <h2 className="font40 extraBold whiteColor">💡 לסיכום</h2>
          <SummaryText className="font18 whiteColor">
            הקלפים שלך הם לא רק קלפים.
            <br />
            הם השפה של הלב שלך,
            <br />
            הם הדרך בה את מדברת עם עצמך,
            <br />
            ומזכירה לך, כל יום, מה באמת חשוב לך. ❤🧡💛
          </SummaryText>
          <SummaryImageRow>
            {/* IMAGE PLACEHOLDER */}
            <SummaryImg className="radius8" style={{ background: "var(--tint-paper)" }}>
              <span style={{ color: "var(--tint-paper)" }}>📸 תמונת סיום 1</span>
            </SummaryImg>
            <SummaryImg className="radius8" style={{ background: "var(--tint-paper)" }}>
              <span style={{ color: "var(--tint-paper)" }}>📸 תמונת סיום 2</span>
            </SummaryImg>
          </SummaryImageRow>
          <BackBtn onClick={() => navigate("home")} className="greenBg darkColor radius8 pointer semiBold font15">
            חזרה לדף הבית
          </BackBtn>
        </div>
      </SummarySection>

      <Footer navigate={navigate} />
    </>
  );
}

/* ---- Styled Components ---- */
const PageHero = styled.section`
  padding: 120px 0 80px;
  direction: rtl;
  @media (max-width: 860px) {
    padding: 100px 0 60px;
    .flexSpaceCenter { flex-direction: column; gap: 40px; }
  }
`;
const HeroText = styled.div`
  width: 55%;
  @media (max-width: 860px) { width: 100%; }
`;
const PageTag = styled.span`
  display: inline-block;
  padding: 5px 14px;
  font-size: 0.813rem;
  font-weight: 600;
`;
const HeroImageBox = styled.div`
  width: 40%;
  @media (max-width: 860px) { width: 100%; }
`;
const HeroImgPlaceholder = styled.div`
  width: 100%;
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  background: var(--grad-blush);
  color: var(--rose-600);
  border: 8px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-lift);
  animation: float 7s ease-in-out infinite;
`;
const Section = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SectionLabel = styled.p``;
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
  p { margin-top: 12px; }
`;
const TwoCol = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  @media (max-width: 860px) { flex-direction: column; }
`;
const TextCol = styled.div`
  flex: 1;
`;
const ImageCol = styled.div`
  flex: 1;
`;
const ImgPlaceholder = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
`;
const BodyText = styled.p`
  line-height: 1.8;
  color: var(--ink-soft);
`;
const ReasonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  margin-bottom: 70px;
  flex-direction: ${(p) => (p.reverse ? "row-reverse" : "row")};
  @media (max-width: 860px) { flex-direction: column; }
`;
const ReasonImageBox = styled.div`
  flex: 1;
`;
const ReasonText = styled.div`
  flex: 1;
`;
const ReasonIcon = styled.div`
  font-size: 2rem;
  margin-bottom: 10px;
`;

/* Gallery */
const GallerySection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); }
`;
const GalleryItem = styled.div``;
const GalleryImg = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;

/* Summary */
const SummarySection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SummaryText = styled.p`
  margin: 25px auto;
  max-width: 600px;
  line-height: 2;
`;
const SummaryImageRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  @media (max-width: 600px) { flex-direction: column; align-items: center; }
`;
const SummaryImg = styled.div`
  width: 280px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  border: 2px dashed rgba(203, 29, 133, 0.45);
`;
const BackBtn = styled.button`
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
